import React from "react";
import "./styles.scss";
import AddBoxIcon from "@mui/icons-material/AddBox";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { isMobile } from "react-device-detect";
import { FILTER_BY_TAG } from "../../../constants/filterConst";
import { strings } from "../../../I18n";

const useStyles = makeStyles(() => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400,
  },
  input: {
    marginLeft: 8, // theme.spacing(1) = 8px
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  filter: {
    minWidth: 350,
  },
}));

function SearchBlock(props) {
  const {
    title,
    searchValue,
    onChange,
    pressFilter,
    addAction,
    clear,
    filterProps,
    removeFilter,
    extraContent = null,
    tagOptions = [],
  } = props;
  const classes = useStyles();
  return (
    <div>
      <div className={"dashboardTitleContainer"}>
        <p className={"dashboardTitle"}>{title}</p>
        <div className={"searchBlockContainer"}>
          <Paper component="form" className={classes.root}>
            <InputBase
              autoFocus={!isMobile}
              className={classes.input}
              placeholder={strings("placeholders.search")}
              value={searchValue}
              onChange={onChange}
              variant={"outlined"}
            />
            <IconButton
              className={classes.iconButton}
              aria-label="clear"
              onClick={clear}
            >
              <CloseIcon />
            </IconButton>
            {(pressFilter || addAction) && (
              <Divider className={classes.divider} orientation="vertical" />
            )}
            {pressFilter && (
              <IconButton
                className={classes.iconButton}
                aria-label="filter"
                onClick={pressFilter}
              >
                <FilterListIcon />
              </IconButton>
            )}
            {addAction && (
              <IconButton
                className={classes.iconButton}
                aria-label="add"
                onClick={addAction}
              >
                <AddBoxIcon />
              </IconButton>
            )}
            {extraContent && extraContent}
          </Paper>
        </div>
      </div>
      {filterProps?.length > 0 &&
        filterProps.map(
          (filter, index) =>
            !!filter.filter && (
              <div key={index} className={"filterDescriptionBloc"}>
                <InputBase
                  className={classes.filter}
                  readOnly={true}
                  placeholder={strings("placeholders.search")}
                  value={`${filter.filterBy
                    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
                    .toLowerCase()}: ${
                    filter.filterBy === FILTER_BY_TAG
                      ? (
                          () => {
                            const ids =
                              typeof filter.filter === "object" &&
                              filter.filter !== null &&
                              !Array.isArray(filter.filter)
                                ? filter.filter.ids || []
                                : Array.isArray(filter.filter)
                                  ? filter.filter
                                  : [filter.filter].filter(Boolean);
                            const match =
                              typeof filter.filter === "object" &&
                              filter.filter !== null &&
                              filter.filter.match
                                ? filter.filter.match
                                : null;
                            const names = ids
                              .map(
                                (id) =>
                                  tagOptions.find((t) => t.id === id)?.name ||
                                  String(id)
                              )
                              .map((name) => name.replace(/_/g, " "));
                            return (
                              names.join(", ") +
                              (match
                                ? `, ${match === "AND" ? "match all" : "match any"}`
                                : "")
                            );
                          }
                        )()
                      : Array.isArray(filter.filter)
                        ? filter.filter
                            .map((f) => String(f).replace(/_/g, " "))
                            .join(", ")
                        : typeof filter.filter === "object" &&
                            filter.filter !== null
                          ? `${(filter.filter.ids || []).join(", ")}${filter.filter.match ? ` (${filter.filter.match})` : ""}`
                          : String(filter.filter).replace(/_/g, " ")
                  }`}
                  variant={"outlined"}
                />
                <IconButton
                  className={classes.iconButton}
                  aria-label="clear"
                  onClick={() => removeFilter(index)}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            )
        )}
    </div>
  );
}

export default SearchBlock;
